export function checkIsNumber (value) {
  if (typeof value == 'number') {
    return true
  }

  if (typeof value == 'string') {
    // eslint-disable-next-line no-self-compare
    return +value === +value
  }

  return false
}

export function formatTextNumber (value, decimal = 0, emptyValue = '0') {
  if (!value) {
    return emptyValue
  }

  value = `${value}`

  const hasEndDot = (decimal && value.endsWith('.')) || ''

  const num = !decimal ? parseInt(value) : parseFloat(value)

  return num.toLocaleString(undefined, { maximumFractionDigits: decimal }) + (hasEndDot && '.')
}

// export function parseTextNumber (value, decimal = 0) {
//   value = value + ''
//   value = (value.includes('.')) && decimal ? (value.substr(0, value.indexOf('.') + decimal + 1)) : value
// debugger;
//   const dict = {
//     '.': 0,
//   }
//   const isNegative = (value[0] == '-' || '')
//   const cleaned = (isNegative && '-') + (value).replace(/[^\d.]/g, '').replace(/[.]/g, (char) => {
//     dict[char]++
//     return dict[char] > 1 ? '' : char
//   })

//   if (cleaned == '-') {
//     return '-'
//   }

//   const newValue = parseFloat(cleaned.replace(/[^\d.]/g, '') || 0)

//   return isNegative ? -newValue : newValue
// }

export function parseTextNumber (value, decimal = 0) {
  // 1. Chuyển giá trị sang chuỗi để xử lý.
  let strValue = String(value);

  // 2. Xử lý dấu âm
  const isNegative = strValue.startsWith('-');
  if (isNegative) {
    // Tạm thời loại bỏ dấu âm để làm sạch độ lớn
    strValue = strValue.substring(1);
  }

  // 3. Làm sạch độ lớn: chỉ giữ lại chữ số và dấu chấm đầu tiên
  let foundDot = false;
  let magnitude = '';
  
  for (const char of strValue) {
    if (/\d/.test(char)) {
      // Giữ lại tất cả các chữ số
      magnitude += char;
    } else if (char === '.') {
      // Giữ lại dấu chấm đầu tiên và bỏ qua các dấu chấm tiếp theo
      if (!foundDot) {
        magnitude += char;
        foundDot = true;
      }
    }
    // Bỏ qua tất cả các ký tự khác (chữ cái, biểu tượng...)
  }

  // 4. Áp dụng Giới hạn Thập phân (chỉ khi có dấu chấm)
  if (foundDot && decimal >= 0) {
    const dotIndex = magnitude.indexOf('.');
    // Cắt chuỗi để chỉ giữ lại (dấu chấm) + (số lượng decimal) chữ số
    // Ví dụ: decimal=1, input '5.123' -> '5.1'
    magnitude = magnitude.substring(0, dotIndex + 1 + decimal);
  }

  // 5. Tái cấu trúc chuỗi đã làm sạch cuối cùng (với dấu âm nếu có)
  let finalCleaned = isNegative ? '-' : '';
  finalCleaned += magnitude;

  // 6. Trả về chuỗi đã làm sạch (STRING) để bảo toàn trạng thái UI (như '5.' hoặc '-')
  if (finalCleaned === '-') {
    return '-'; 
  }

  if (finalCleaned === '') {
    // Cho phép người dùng xóa hết input
    return ''; 
  }
  
  // Dòng này đã được loại bỏ: 
  // const newValue = parseFloat(finalCleaned) || 0; 
  // Vì nó làm mất dấu chấm.
  return finalCleaned;
}


export function formatTextCurrency (value, prefix = 'VNĐ ', suffix = '') {
  const textNumber = formatTextNumber(value)
  return `${textNumber} ${prefix}${suffix}`
}

export function randomInt (from = 0, to = 100) {
  const min = Math.ceil(from)
  const max = Math.floor(to)
  return Math.floor(Math.random() * (max - min + 1)) + min
}
